import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { useViewportDevice } from '@zep/react';
import { Colors } from '@zep/ui-tokens';
import { ChevronRightIcon } from '../../../../icons';
import { useSubscriptionPaymentContext } from '../hooks';
import S from './SubscriptionPaymentSteps.module.scss';
export const SubscriptionPaymentSteps = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    step
  } = useSubscriptionPaymentContext();
  const {
    isMobile
  } = useViewportDevice();
  return <div className={S.wrapper} data-sentry-component="SubscriptionPaymentSteps" data-sentry-source-file="SubscriptionPaymentSteps.tsx">
      <PlanCheckoutStep step={1} active={step === 1} label={t('subscription:payment.phase.planSelect')} data-sentry-element="PlanCheckoutStep" data-sentry-source-file="SubscriptionPaymentSteps.tsx" />
      <ChevronRightIcon width={isMobile ? 16 : 14} height={isMobile ? 16 : 14} fill={Colors.Gray300} data-sentry-element="ChevronRightIcon" data-sentry-source-file="SubscriptionPaymentSteps.tsx" />
      <PlanCheckoutStep step={2} active={step === 2} label={t('subscription:payment.phase.cardRegister')} data-sentry-element="PlanCheckoutStep" data-sentry-source-file="SubscriptionPaymentSteps.tsx" />
    </div>;
};
const PlanCheckoutStep = ({
  step,
  label,
  active
}: {
  step: number;
  label: string;
  active: boolean;
}) => {
  return <div className={cns(S.item, {
    [S.item_active]: active
  })} data-sentry-component="PlanCheckoutStep" data-sentry-source-file="SubscriptionPaymentSteps.tsx">
      <span className={cns(S.round, {
      [S.round_active]: active
    })}>{step}</span>{' '}
      {label}
    </div>;
};